import { initializeMessenger } from '../../messengers'
import { v4 as uuidv4 } from 'uuid'

const messenger = initializeMessenger({ connect: 'background' })

export const callWallet = async (action: string, wallet: string, payload?: unknown) => {
  const { result }: { result: unknown } = await messenger.send(
    'plug_wallet_action',
    {
      action,
      payload,
      wallet,
    },
    { id: uuidv4() }
  )
  return result
}
